<template>
    <footer id="sek-footer">
        <container>
            <slot>
                <div class="sek-footer-parceiros">
                    <container-title
                        title="Nossos"
                        sub-title="Parceiros" />
                    <drag-items
                        id="sek-footer-parceiros-items"
                        :items="parceiros" />
                </div>
            </slot>
            <div class="footer-content">
                <v-row>
                    <v-col
                        v-for="item in content"
                        :key="item.title" 
                        col="12"
                        sm="6"
                        md="2"
                        lg="2">
                        <p class="mb-0"><b>{{ item.title }}</b></p>
                        <p 
                            v-for="body in item.content"
                            :key="body"
                            class="mb-0 font-weight-light">
                            {{ body }}
                        </p>
                    </v-col>
                </v-row>
                <v-row style="margin-top: 55px">
                    <v-col
                        col="12"
                        sm="12"
                        md="9"
                        lg="9">
                        <p class="mb-0">A tecnologia faz parte de nosso dna</p>
                    </v-col>
                    <v-col
                        col="12"
                        sm="12"
                        md="3"
                        lg="3">
                        <p class="mb-2">Redes sociais</p>
                        <div class="d-flex">
                            <a 
                                class="footer-icon-link"
                                href="https://www.instagram.com/sek_assessoria/"
                                target="_blank">
                                <v-icon 
                                    size="30px"
                                    v-ripple
                                    class="footer-icon mx-1"
                                    color="white">mdi-instagram</v-icon>
                            </a>
                            <a 
                                class="footer-icon-link"
                                href="https://br.linkedin.com/company/sek-assessoria-de-seguros-e-benef%C3%ADcios/"
                                target="_blank">
                                <v-icon 
                                    size="30px"
                                    v-ripple
                                    class="footer-icon mx-1"
                                    color="white">mdi-linkedin</v-icon>
                            </a>
                            <a 
                                class="footer-icon-link"
                                href="https://www.facebook.com/sekassessoria"
                                target="_blank">
                                <v-icon 
                                    size="30px"
                                    v-ripple
                                    class="footer-icon mx-1"
                                    color="white">mdi-facebook</v-icon>
                            </a>
                        </div>
                    </v-col>
                </v-row>               
                
            </div>
            <p class="mb-0 text-center font-14"> Copyright © SekAssessoria. Todos os direitos reservados. </p>
        </container>
    </footer>
</template>

<script>
import DragItems from "../utils/DragItems.vue"
import ContainerTitle from "../utils/ContainerTitle.vue"

export default {
    components: {
        "drag-items": DragItems,
        "container-title": ContainerTitle,
    },
    data() {
        return {
            content: [
                { title: "Endereço", content: ["Ed Radio Center - Brasília", "1º andar sala 1094", "Asa Norte"]},
                { title: "Telefone", content: ["+55 (61) 3327-7036"]},
                { title: "Whatsapp", content: ["+55 (61) 3327-7036"]},
                { title: "E-mail", content: ["comercial@sekassessoria.com.br"]},
                { title: "Empresa", content: ["SEK ASSESSORIA E CORRETORA DE SEGUROS LTDA"]},
                { title: "CNPJ", content: ["29.773.882/0001-00"]},
            ],
            parceiros: [
                {
                    href: "https://www.compline.com.br/#/",
                    src: require('@/assets/images/compline.png')
                },
                {
                    href: "http://www.amil.com.br/institucional/#/",
                    src: require('@/assets/images/amil.png')
                },
                {
                    href: "https://www.unimed.coop.br/",
                    src: require('@/assets/images/unimed.png')
                },
                {
                    href: "https://www.bradescoseguros.com.br/clientes",
                    src: require('@/assets/images/bradesco.png')
                },
                {
                    href: "https://portal.sulamericaseguros.com.br/home.htm",
                    src: require('@/assets/images/sulamerica.png')
                },
                {
                    href: "https://www.portoseguro.com.br/",
                    src: require('@/assets/images/porto-seguro.png')
                },
            ]
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/styles/utils.scss";

#sek-footer {
    padding-top: 75px;
    background: rgba(20,21,23,1);
    color: $c-white;

    .footer-content {
        line-height: 20px;
    }

    #sek-footer-parceiros-items {
        margin-top: 50px;
        margin-bottom: 95px;
    }

    .footer-icon-link {
        text-decoration: none;
    }
}
</style>